"use strict";
$(document).ready(function(){
		function heightMesure() {
		var mh = 0;
		// .preview-slider .column
		var newsItem = $(".news-slider .item");
		newsItem.each(function() {
			var h_block = parseInt($(this).height());
			if (h_block > mh) {
				mh = h_block;
			};
		});
		newsItem.height(mh);

	}
	heightMesure();

	var navLink = $('.gallery .mobile-show .show-item .link-click');

	navLink.click(function(){
		$('.hide-items').toggleClass('active');
		$('.mobile-show').toggleClass('active');

	});


  $(".up a").click(function() {
      $("html, body").animate({
         scrollTop: $($(this).attr("href")).offset().top + "px"
      }, {
         duration: 10,
         easing: "linear"
      });
      return false;
   });
});